import { IPlanContent } from '../typings';
import { createPlanNameMatcher } from './utils/PlanMetaHelper';
import { defaultEstimatesDialog, ongoingKeyDetails } from './common/planDefaults';
import { STANDING_RETAIL_TERMS_URL_BY_STATE } from './common/standingRetailTerms';

export const ORIGIN_STANDING_SOLAR_SHARER_PLAN_NAME = 'Origin Standing Solar Sharer';

export const originStandingSolarSharerContent: IPlanContent = {
  test: createPlanNameMatcher([ORIGIN_STANDING_SOLAR_SHARER_PLAN_NAME]),
  content: {
    keyDetails: {
      defaultState: {
        defaultFuel: ongoingKeyDetails,
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        gas: [],
        dual: [],
        electricity: [],
      },
    },
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'orange',
              odsCore: 'neutral',
            },
            promobox: {
              styleGuide: 'lightOrange',
              odsCore: 'neutral',
            },
            bannerText: {
              styleGuide: 'grey56',
              odsCore: 'neutralDark',
            },
          },
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-standing-solar-share.svg',
            gas: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-standing-solar-share.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-standing-solar-share.svg',
          },
        },
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
    termsAndConditionsUrl: {
      ACT: { defaultFuel: STANDING_RETAIL_TERMS_URL_BY_STATE.ACT },
      NSW: { defaultFuel: STANDING_RETAIL_TERMS_URL_BY_STATE.NSW },
      VIC: { defaultFuel: STANDING_RETAIL_TERMS_URL_BY_STATE.VIC },
      QLD: { defaultFuel: STANDING_RETAIL_TERMS_URL_BY_STATE.QLD },
      SA: { defaultFuel: STANDING_RETAIL_TERMS_URL_BY_STATE.SA },
      WA: { defaultFuel: STANDING_RETAIL_TERMS_URL_BY_STATE.WA },
    },
  },
};
